<template>
	<div class="wrapper">
		<!-- <div class="modal" :class="{ hide: !pageLoading }">
			<div id="main-spinner" class="page-spinner-wrapper main-spinner">
				<span class="spinner-circle"></span>
			</div>
		</div> -->
		<div v-if="!pageLoading" class="murk">
			<BalanceInfo
				:title="
					isIngamePurchase
						? $t('checkout.title')
						: region === 'global'
						? $t('checkout.buy-nx')
						: $t('add-balance')
				"
				:show-switch-account="!isIngamePurchase"
				:is-in-game="isIngamePurchase"
			/>

			<div class="purchase-wrapper">
				<div class="summary-container">
					<InGameSummary v-if="isIngamePurchase" />
					<Summary v-else />
				</div>

				<div class="billing-payment-container">
					<!--billing location is only for west region -->
					<BillingLocation v-if="region === 'global'" />
					<PaymentMethod />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BalanceInfo from '@/components/common/balance-info';
import Summary from './summary';
import InGameSummary from '@/components/in-game/summary';
import BillingLocation from './billing-location';
import PaymentMethod from './payment-method';

export default {
	name: 'Purchase',
	components: {
		BalanceInfo,
		Summary,
		InGameSummary,
		BillingLocation,
		PaymentMethod,
	},
	data() {
		return {
			pageLoading: false,
		};
	},
	computed: {
		isIngamePurchase() {
			return this.$route.name === 'in-game-purchase' || this.$store.state.appType === 'game';
		},
		showBillingLocationFields() {
			return this.$store.state.showBillingLocationFields;
		},
	},
	mounted() {
		if (this.showBillingLocationFields) {
			this.$a2s.view('location_imp');
		} else {
			this.$a2s.view('purchase_method_imp');
		}
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			if (vm.$store.state.token && !vm.$store.state.checkoutId) {
				vm.$router
					.replace({
						name: 'checkout',
						params: {
							locale: to.params.locale,
						},
						query: {
							token: vm.$store.state.token,
						},
					})
					.catch(() => {});
			}
		});
	},
};
</script>

<style lang="less" scoped>
.purchase-wrapper {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	margin-top: 50px;
	margin-left: -10px;
	margin-right: -10px;
	line-height: 1;
	.summary-container,
	.billing-payment-container {
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
		flex: 0 0 50%;
		max-width: 50%;
		padding-left: 10px;
		padding-right: 10px;
	}
	.summary-container {
		margin-bottom: 0;
	}
}

@media (min-width: 1024px) {
	.purchase-wrapper {
		.summary-container {
			order: 2;
		}
		.billing-payment-container {
			order: 1;
		}
	}
}
@media (max-width: 1023px) {
	.purchase-wrapper {
		margin-left: 0px;
		margin-right: 0px;
		margin-top: 20px;
		justify-content: center;
		.summary-container,
		.billing-payment-container {
			flex: 0 0 100%;
			max-width: 100%;
			padding-left: 0px;
			padding-right: 0px;
			max-width: 750px;
		}
		.summary-container {
			margin-bottom: 20px;
		}
	}
}
</style>
